var _templateObject = _taggedTemplateLiteralLoose(['\n  height: 48px;\n  border: 1px solid ', ';\n  font-family: ', ';\n  outline: none;\n  font-size: 1rem;\n  padding: 0.375rem 0.75rem;\n  width: 100%;\n  background-color: ', ';\n  transition: border-color 0.15s ease-in-out;\n  &:focus {\n    border: 2px solid ', ';\n    background-color: #fff;\n  }\n'], ['\n  height: 48px;\n  border: 1px solid ', ';\n  font-family: ', ';\n  outline: none;\n  font-size: 1rem;\n  padding: 0.375rem 0.75rem;\n  width: 100%;\n  background-color: ', ';\n  transition: border-color 0.15s ease-in-out;\n  &:focus {\n    border: 2px solid ', ';\n    background-color: #fff;\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React, { useState } from 'react';
import Theme from '../../Theme';
import styled from 'styled-components';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import PropTypes from 'prop-types';

export var StyledPicker = styled(DatePicker)(_templateObject, function (_ref) {
  var hasError = _ref.hasError;
  return hasError ? Theme.colors.danger : Theme.colors.darkgrey;
}, Theme.fonts.Montserrat, function (_ref2) {
  var hasError = _ref2.hasError;
  return hasError ? Theme.colors.dangerLight : '#fff';
}, function (_ref3) {
  var hasError = _ref3.hasError;
  return hasError ? Theme.colors.danger : Theme.colors.lightBlue;
});

export var useSetDate = function useSetDate(setFieldValueFn, name) {
  var _useState = useState(null),
      startDate = _useState[0],
      setStartDate = _useState[1];

  var setDate = function setDate(e) {
    setStartDate(e);
    setFieldValueFn(name, startDate);
  };
  return [startDate, setDate];
};

export var FormikDatePicker = function FormikDatePicker(_ref4) {
  var name = _ref4.name,
      placeholder = _ref4.placeholder,
      setFieldValue = _ref4.setFieldValue,
      className = _ref4.className,
      hasError = _ref4.hasError;

  var _useSetDate = useSetDate(setFieldValue, name),
      startDate = _useSetDate[0],
      setDate = _useSetDate[1];

  return React.createElement(StyledPicker, {
    className: className,
    name: name,
    hasError: hasError,
    placeholderText: placeholder,
    isClearable: true,
    onChange: setDate,
    selected: startDate });
};

FormikDatePicker.displayName = 'FormikDatePicker';

FormikDatePicker.propTypes = process.env.NODE_ENV !== "production" ? {
  name: PropTypes.string.isRequired,
  hasError: PropTypes.bool,
  placeholder: PropTypes.string,
  setFieldValue: PropTypes.func.isRequired,
  className: PropTypes.any
} : {};

export default FormikDatePicker;